/* eslint-disable camelcase */
import React, { useContext } from "react"
import Header from "../../layouts/Header"
import { createTheme, ThemeProvider, styled } from "@mui/material/styles"
import { Box, Typography, Chip } from "@mui/material"
import BackIcon from "../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import { GlobalContext } from "../../contexts/GlobalContext"
import getIconComponent from "../utils/getIconComponent"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../utils/reactTableActions/exportToolbarActions"
import CheckIcon from "@mui/icons-material/Check"

const StyledRootStyles = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "20px",
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const GestiondeCartera = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            Bandeja de Gestión de Cartera
          </Typography>
        </Box>

        <StyledRootStyles>
          <CustomConditionalActionsTableServer
            endpoint="/GestiondeCartera/getResumenCartera"
            errorMsgFilterSearch="Error al cargar la bandeja de cartera"
            queryKeyModal={`ResumenCartera_Dinamico`}
            perPage={10}
            rowActionsWidthTable={120}
            rowActions={(row) => {
              const gestionarAction = selectedMenuInfo?.data?.barraAcciones?.find(
                (a) => a.acccaption === "GESTIONAR" || a.acccaption === "EDITAR",
              )
              const actions = []

              actions.push({
                label: gestionarAction ? gestionarAction.acccaption : "Gestionar Cuota",
                key: "gestionar",
                icon: gestionarAction ? (
                  getIconComponent(gestionarAction.accnameicono, gestionarAction.acctipoico)
                ) : (
                  <CheckIcon color="success" />
                ),
                onClick: (row) => navigate("detalle", { state: { cliente: row.original } }),
              })

              return actions
            }}
            topToolbarCustomActions={({ table, device }) => {
              const acciones = selectedMenuInfo?.data?.barraAcciones || []
              const toolbarActions = []

              const exportarAction = acciones.find((a) => a.acccaption === "EXPORTAR")
              if (exportarAction) {
                toolbarActions.push({
                  type: "dropdown",
                  label: exportarAction.acccaption,
                  key: "exportDropdown",
                  icon: getIconComponent(exportarAction.accnameicono, exportarAction.acctipoico),
                  actions: [
                    {
                      label: "Exportar PDF",
                      key: "pdf",
                      onClick: ({ columns, data }) => {
                        const title = `Bandeja de Cartera`
                        device === "sm"
                          ? handleExportDataPdfSMScreen(columns, data, title, title)
                          : handleExportDataPdfLGScreen(columns, table.getCoreRowModel().rows, title, title)
                      },
                    },
                    {
                      label: "Exportar CSV",
                      key: "csv",
                      onClick: ({ data }) => handleAllExportDataCSV(data, `Cartera_SIAC`),
                    },
                  ],
                })
              }
              return toolbarActions
            }}
            // === COLUMNAS CON ESTADO DE GESTIÓN Y COMPROMISO INCLUIDOS ===
            columnsTable={[
              { accessorKey: "clicodigo", header: "Cód. Cliente", size: 110 },
              { accessorKey: "clinombre", header: "Nombre del Cliente", size: 300 },
              {
                accessorKey: "estado_compromiso",
                header: "Compromiso",
                size: 140,
                Cell: ({ cell }) => {
                  const val = cell.getValue()
                  if (val === "ATRASADO") {
                    return <Chip label="ATRASADO" color="error" size="small" sx={{ fontWeight: "bold" }} />
                  }
                  if (val === "A TIEMPO") {
                    return <Chip label="A TIEMPO" color="success" size="small" sx={{ fontWeight: "bold" }} />
                  }
                  return <span style={{ color: "#9e9e9e", fontStyle: "italic" }}>N/A</span>
                },
              },
              {
                accessorKey: "estado_gestion",
                header: "Gestión",
                size: 140,
                Cell: ({ cell }) => {
                  const val = cell.getValue()
                  if (val === "Sin Gestionar") {
                    return <span style={{ color: "#9e9e9e", fontStyle: "italic" }}>Sin Gestionar</span>
                  }
                  return <span style={{ fontWeight: "bold", color: "#196C87" }}>{val}</span>
                },
              },
              {
                accessorKey: "usrrecaudador",
                header: "Recaudador",
                size: 130,
                Cell: ({ cell }) =>
                  cell.getValue() ? (
                    <span style={{ fontWeight: "bold", color: "#196C87" }}>{cell.getValue()}</span>
                  ) : (
                    <span style={{ color: "#9e9e9e", fontStyle: "italic" }}>Sin asignar</span>
                  ),
              },
              {
                accessorKey: "saldo_vencido",
                header: "Cartera Vencida ($)",
                size: 160,
                Cell: ({ cell }) => {
                  const val = Number(cell.getValue() || 0)
                  return (
                    <span style={{ fontWeight: "bold", color: val > 0 ? "#b71c1c" : "inherit" }}>
                      ${val.toFixed(2)}
                    </span>
                  )
                },
              },
              {
                accessorKey: "saldo_por_vencer",
                header: "Por Vencer ($)",
                size: 150,
                Cell: ({ cell }) => {
                  const val = Number(cell.getValue() || 0)
                  return (
                    <span style={{ fontWeight: "bold", color: val > 0 ? "#2E7D32" : "inherit" }}>
                      ${val.toFixed(2)}
                    </span>
                  )
                },
              },
              {
                accessorKey: "saldo_total",
                header: "Saldo Total ($)",
                size: 150,
                Cell: ({ cell }) => (
                  <span style={{ fontWeight: "bold", color: "#196C87", fontSize: "1.05em" }}>
                    ${Number(cell.getValue() || 0).toFixed(2)}
                  </span>
                ),
              },
            ]}
          />
        </StyledRootStyles>
      </div>
    </ThemeProvider>
  )
}

export default GestiondeCartera
